import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState } from '../reducers/application.reducer';

export const selectApplicationState = createFeatureSelector<ApplicationState>('application');

export const selectApplication = createSelector(selectApplicationState, state => state.application);

export const selectServiceAttachmentPositions = createSelector(selectApplicationState, (state) => state.serviceAttachmentPositions);

export const selectApplicationList = createSelector(selectApplicationState, state => state.applicationList);

export const selectLoading = createSelector(selectApplicationState, state => state.loading > 0);

export const selectPending = createSelector(selectApplicationState, state => state.pending > 0);
